<div class="details__wrapper">
    <div class="details__head background-animate">
        <div class="head__title">
            ...
        </div>
        <div class="head__info"></div>
    </div>
    <div class='details__image background-animate'></div>
    <div class='details__body background-animate'></div>
</div>

<style>
    .details__wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px
    }

    .details__head {
        display: flex;
        justify-content: space-between;
        background-color: grey;
        padding: 10px;
        color: white;
    }

    .details__image {
        width: 100%;
        height: 300px;
    }

    .details__body {
        width: 100%;
        height: 500px;
    }
</style>